const KEY = "cmm_pin";
export const getPin = () => localStorage.getItem(KEY) || "";
export const setPin = (pin) => localStorage.setItem(KEY, pin);
export const clearPin = () => localStorage.removeItem(KEY);
export const authHeaders = () => ({ "X-Access-Code": getPin() });

export const handleUnauthorized = (res) => {
  if (res.status === 401) {
    clearPin();
    window.dispatchEvent(new Event("cmm-pin-invalid"));
    throw new Error("Codice di accesso non valido: reinseriscilo");
  }
};
